// extracted by mini-css-extract-plugin
export default {"btn":"DeleteLiber_btn__uphtK","title":"DeleteLiber_title__TkqNB","input":"DeleteLiber_input__fmC+p"};